const Validation = {
  methods: {
    /**
     * nameRulesWithType - is name validation method
     * @date 2021-10-28
     * @returns {Array} - with error message.
     */
    nameRulesWithType: (nameType) => v => (v?.length <= 10) || `${nameType} must be less than 10 characters`,
    /**
     * Validate - is check to valid form
     * @date 2020-11-30
     * @returns {Boolean} - validation state.
     */
    validate () {
      console.log('validate', this.$refs.form.validate())
      return this.$refs.form.validate()
    },
    /**
     * Reset form
     * @date 2020-11-30
     * @returns {any}
     */
    reset () {
      this.$refs.form.reset()
    },

    /**
     * Reset validation
     * @date 2020-11-30
     * @returns {any}
     */
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    /**
     * Set dynamic validation rules
     */
    setDynamicValidationRules (data) {
      console.log('setDynamicValidationRules', data)
      for (const key in data) {
        this[key] = data[key]
      }
    }
  },
  computed: {
    /**
     * cfmPwdRule - is confirm password validation method
     * @date 2021-10-28
     * @returns {Array} - with error message. In component should add to data 'cfmPwd' property
     */
    cfmPwdRule () {
      return () => {
        return (this.form.confirmPassword === this.form.password) || 'The password doesn\'t match'
      }
    }
  }
}

export default Validation
